import React, { Component } from 'react'
import { Row, Col, Input, Button, Space, Table, message } from 'antd';
import './camera-list.less';
import { camera } from '@/interface/camera';
import { inject, observer } from 'mobx-react';
import { ProjectContext } from '@/config/context';
// import { queryCameras, deleteCamera, updateCamera } from '@/config/api/camera';
import GlobalDeviceStore from '@/store/global-device';
// import { queryGlobalCameras } from '@/config/api/global-device';
import { cameraWorkStatus } from '@/utils/type';
import { queryMobjects } from '@/config/api/mobject';
import axios from '@/config/axios';
import { mobject } from '@/interface/mobject';
import CameraStatistics from '@/components/device-list/device-statistics';
import { Tag } from 'antd';
import { withRoutePane } from '@/components/hoc/routePane';
import { SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { EditableRow, EditableCell, CameraAddPanel } from '@/components';
// import { EditableRow, EditableCell, CameraAddPanel } from '@/components';
import classnames from 'classnames';
import { Gprops } from '@/config/props';
import { queryGlobalCameras } from '@/config/api/global-device';
import { queryCameras } from '@/config/api/camera';

const { Column } = Table;

export const CameraStatusTypesEnum = {
    OFFLINE: 0,
    ONLINE: 1,
    ABNORMAL: 2,
}

interface IProps extends Gprops {
    globalDeviceStore?: GlobalDeviceStore,
}

interface IState {
    cameras: camera[]
    displayCameras: camera[],
    loading: boolean,
    pagination: any
    statistics: any[]
    inputValue: string,
    onDeleteState: boolean  // 切换删除状态
    cameraIdToDelete: number[]  // 缓存即将删除的摄像头
    deleteLoading: boolean
    onAddState: boolean  // 切换添加状态
    onEditState: boolean
    cameraDownloadLoading: boolean
}

@inject('globalDeviceStore')
@observer
class CameraListPage extends Component<IProps, IState> {

    static contextType = ProjectContext;
    projectMobjects: mobject[] = [];

    constructor(props) {
        super(props);
        this.state = {
            cameras: [],
            displayCameras: [],
            pagination: {
                pageSize: 30,
            },
            loading: false,

            statistics: [],
            inputValue: null,
            onDeleteState: false,
            cameraIdToDelete: [],
            deleteLoading: false,
            onAddState: false,
            onEditState: false,
            cameraDownloadLoading: false,
        }
    }

    componentDidMount() {
        this.loadCameras();
    }

    loadCameras = () => {
        //TODO
        let queryGlobalCamerasPromise = queryGlobalCameras();
        let queryMobjectsPromise = queryMobjects({ project_id: this.context });
        let queryCamerasPromise = queryCameras({
            project_id: this.context,
        });
        this.setState({
            loading: true,
        })
    
        axios.all([queryGlobalCamerasPromise, queryMobjectsPromise, queryCamerasPromise])
            .then(res => {
                let gCameras = res[0].data || [];
                this.projectMobjects = res[1].data || [];
                let cameras = res[2].data || [];
                console.log(cameras);
                cameras = cameras.sort((a, b) => a.name > b.name ? 1 : -1);
                this.props.globalDeviceStore.globalCameras(gCameras);
                // 设备统计
                let count = this.countStatistic(cameras);
                let display = cameras.filter(item => item.name.indexOf(this.state.inputValue || '') >= 0) || [];
                console.log(cameras);
                // 更新数据渲染
                this.setState({
                    cameras: cameras,
                    statistics: count,
                    displayCameras: display,
                    pagination: {
                        pageSize: 18,
                        total: cameras.length
                    },
                    loading: false,
                })
            }).finally(() =>{
                this.setState({
                    loading: false,
                })
            })
    }

    countStatistic = (value: camera[]) => {
        let statistics = new Map();
        value.forEach((camera: camera) => {
            if (!statistics[camera.marking]) {
                statistics[camera.marking] = 1;
            } else {
                statistics[camera.marking]++;
            }
        });
        let res = [];
        for (let key of Object.keys(statistics).sort()) {
            let name = this.props.globalDeviceStore._globalCameras.filter(item => item.marking === key)[0];
            res.push({ marking: key, count: statistics[key], name: name ? name.name : '' });
        }
        return res;
    }

    handleSearchChange = (value) => {
        let display = this.state.cameras.filter(item => item.name.indexOf(value) >= 0) || [];
        this.setState({
            displayCameras: display
        })
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            cameraIdToDelete: [...selectedRowKeys]
        })
    }

    onDelete = () => {
        message.warning("功能尚未实现！");
        //TODO
    }

    onSave = () => {
        this.setState({
            onAddState: false,
        })
        this.loadCameras();
    }


    handleRowSave = (row: camera) => {
        message.warning("功能尚未实现！");
        //TODO
    }

    downloadCsv = () => {
        message.warning("功能尚未实现！");
        //TODO
    }

    render() {
        let { onDeleteState, cameraIdToDelete, onAddState, onEditState } = this.state;
        return (
            <Row className="camera-list-page">
                <Col xs={24} xxl={18}>
                    <div className="left">
                        <div className="header-tools">
                            {!onAddState && (
                                <Input
                                    placeholder="搜索摄像头"
                                    suffix={<SearchOutlined />}
                                    className="search-input"
                                    value={this.state.inputValue}
                                    onChange={(e) => this.setState({ inputValue: e.target.value })}
                                    onPressEnter={() => this.handleSearchChange(this.state.inputValue)}
                                    onBlur={() => this.handleSearchChange(this.state.inputValue)} />
                            )}

                            <div className="fill-remaining-space"></div>
                            {!onDeleteState && !onAddState && !onEditState && (
                                <Space size='middle'>
                                    {/* <Button>导入csv</Button> */}
                                    <Button loading={this.state.cameraDownloadLoading} onClick={this.downloadCsv}>导出csv</Button>
                                    <Button type="primary" icon={<PlusOutlined />} onClick={() => this.setState({ onAddState: true })}></Button>
                                    <Button icon={<EditOutlined />} onClick={() => this.setState({ onEditState: true })}></Button>
                                    <Button danger icon={<DeleteOutlined />} onClick={() => this.setState({ onDeleteState: true })}></Button>
                                </Space>
                            )}
                            {onDeleteState && (
                                <Space>
                                    <Button danger onClick={this.onDelete} loading={this.state.deleteLoading}>确定</Button>
                                    <Button onClick={() => this.setState({ onDeleteState: false })}>取消</Button>
                                </Space>
                            )}
                            {onEditState && (
                                <Space>
                                    <Button type="primary" onClick={() => this.setState({ onEditState: false })}>完成</Button>
                                </Space>
                            )}

                        </div>
                        {onAddState && (
                            <CameraAddPanel
                                gCameras={this.props.globalDeviceStore._globalCameras}
                                onCancel={() => this.setState({ onAddState: false })}
                                onSave={this.onSave} />
                        )}
                        <div className="list-content">
                            <Table 
                            dataSource={this.state.displayCameras} 
                            rowKey="id" 
                            pagination={this.state.cameras?.length > 30 ? {
                                pageSize: 30
                            } : false }
                            loading={this.state.loading}
                            rowClassName={classnames({
                                'click-row': !onEditState && !onDeleteState
                            })}
                            components={{
                                body: {
                                    row: EditableRow,
                                    cell: EditableCell,
                                }
                            }}
                            onRow={record => {
                                if (onEditState || onDeleteState) {
                                    return null;
                                }
                                return {
                                    onClick: _ => {
                                        this.props.history.push(`${this.props.match.url}/${record.id}`);
                                    },
                                }
                            }}
                            rowSelection={onDeleteState && {
                                type: 'checkbox',
                                onChange: this.onSelectChange,
                                selectedRowKeys: cameraIdToDelete
                            }}>
                                <Column 
                                title="名称"
                                dataIndex="name" 
                                width="15%"
                                onCell={(record: camera, idx) => ({
                                    record,
                                    editable: onEditState,
                                    dataIndex: 'name',
                                    title: '名称',
                                    handleSave: this.handleRowSave,
                                })} />
                                <Column title="编号" dataIndex="camera_id" />
                                <Column title="型号" dataIndex="marking" />
                                <Column title="设备号" dataIndex="device_id" />
                                <Column title="通道号" dataIndex="channel_id" />
                                {/*
                                TODO 现在没有判断摄像头的状态，状态栏没有意义

                                <Column title="状态" dataIndex="work_status" render={(record) => (
                                    <Tag color={cameraWorkStatus[record]['color']}>{cameraWorkStatus[record]['value']}</Tag>
                                )} />

                                */}
                            </Table>
                        </div>
                    </div>
                </Col>
                <Col xs={24} xxl={6}>
                    <div className="right device-statistics">
                        <CameraStatistics statistic={this.state.statistics} />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRoutePane(CameraListPage, '摄像头列表');